import { sendEvent } from 'tracking';

export const metrics = {
  showShortNotification: () => sendEvent('Notifications: Show short notification'),
  showFullNotification: () => sendEvent('Notifications: Show full notification'),
  clickOnLearnMore: () => sendEvent('Notifications: Click on learn more button'),
  clickOnHide: () => sendEvent('Notifications: Click on hide button'),
  clickOnButton: () => sendEvent('Notifications: Click on button in full notification'),
};
